import { GetServerSideProps } from 'next';
import dynamic from 'next/dynamic';
import { NavBarContent } from '@/components/Navbar';
import { api, site } from '@/services/api';
import InstitutionalPage from '@/components/Institutional/InstitutionalPage';
import { HeadTags } from '@/shared/types/home.types';
import { AdvertiseHereProps } from '@/components/Institutional/AdvertiseHere';
import getConcurrentPromises from '@/utils/getConcurrentPromises';
import Layout from '@/components/Layout';
import { SchemaType } from '@/components/Internals/InternalSchema';

interface NavBarContentData {
  data: NavBarContent;
}

export interface Stats {
  quantidade: string;
  label: string;
  icone: string;
}

interface AdvertiseProps {
  advertiseData: {
    data: {
      seo: {
        title: string;
        description: string;
      };
      cabecalho: {
        titulo: string;
        descricao: string;
        imagem: { url: string; srcset: { [key: number]: string }; blurhash: string };
      };
      corpo: {
        texto: string;
      };
      estatisticas: AdvertiseHereProps['estatisticas'];
      midiaKit: AdvertiseHereProps['midiaKit'];
      parceiros: AdvertiseHereProps['parceiros'];
    };
    schema?: SchemaType;
  };
  ssr: HeadTags[];
  navBarData: NavBarContent;
}

export default function Advertise({ advertiseData, navBarData, ssr }: AdvertiseProps) {
  const { data, schema } = advertiseData;
  const { cabecalho, estatisticas, corpo, midiaKit, parceiros } = data;

  return (
    <Layout layoutData={{ segmentacoes: [], tagsData: ssr, navBarData, schema }}>
      <InstitutionalPage
        text={corpo.texto}
        title={cabecalho.titulo}
        headerImg={{ url: cabecalho.imagem.url, blurhash: cabecalho.imagem.blurhash, srcset: cabecalho.imagem.srcset }}
        breadcrumbs={[]}
        advertiseData={{ estatisticas, midiaKit, parceiros }}
        type="anuncie"
      />
    </Layout>
  );
}

export const getServerSideProps: GetServerSideProps = async context => {
  const { host } = context.req.headers;

  const mainReq = { promise: site.get<AdvertiseProps>(`/anuncie/`), link: `/anuncie/` };
  const responseMenuReq = { promise: api.get<NavBarContentData>(`/componentes/menu/`), link: `/componentes/menu/` };

  const { promiseData, data, statusCode } = await getConcurrentPromises({
    mainPromise: mainReq,
    navBarPromise: responseMenuReq,
    host,
  });

  if (data.redirect || data.notFound) return data;

  const navBarData: NavBarContentData = promiseData[responseMenuReq.link].data.data;
  const { ssr, headers } = data;

  context.res.setHeader('Cache-Control', headers['Cache-control']);
  context.res.setHeader('Expires', headers.Expires);
  context.res.statusCode = statusCode;

  const advertiseData = data;

  return {
    props: {
      advertiseData,
      navBarData,
      ssr,
      headers,
    },
  };
};
